import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Download } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function PricingSection() {
  return <section id="pricing" className="py-12 md:py-24 px-4 bg-forest-900 relative overflow-hidden" data-id="element-94">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,_var(--tw-gradient-stops))] from-amber-500/10 via-transparent to-transparent" data-id="element-95"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-96">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-6 md:mb-12" data-id="element-97">
          <p className="text-xl md:text-2xl font-playfair text-cream-100/90 leading-relaxed max-w-2xl mx-auto italic" data-id="element-98">
            "Obtén hoy 'Farmacia de Despensa: El Botiquín de Cocina' por un pago
            único. Recupera tu autonomía de salud por menos de lo que cuesta una
            caja de analgésicos de marca."
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="relative max-w-lg mx-auto" data-id="element-99">
          {/* Decorative borders */}
          <div className="absolute -inset-1 bg-gradient-to-tr from-amber-600 via-amber-400 to-amber-600 rounded-sm blur-[2px] opacity-70" data-id="element-100"></div>

          <div className="relative bg-forest-950 p-8 md:p-12 rounded-sm border border-amber-500/50 shadow-2xl flex flex-col items-center text-center" data-id="element-101">
            <div className="inline-block px-4 py-1.5 rounded-full bg-amber-500/20 border border-amber-500/50 text-amber-400 font-bold text-sm tracking-wider uppercase mb-8 font-lora" data-id="element-102">
              Precio Especial de Lanzamiento
            </div>

            {/* Original price struck through */}
            <div className="flex items-center justify-center mb-2 text-cream-200/50" data-id="element-103">
              <span className="text-lg font-playfair line-through" data-id="element-104">
                $27 USD
              </span>
            </div>

            {/* Discount badge */}
            <div className="inline-block px-3 py-1 rounded-full bg-red-600 text-white font-bold text-sm tracking-wider uppercase mb-4 font-lora animate-pulse" data-id="element-105">
              -76% de descuento
            </div>

            {/* Final price */}
            <div className="flex items-start justify-center mb-8" data-id="element-106">
              <span className="text-3xl font-playfair text-amber-500 mt-2 mr-1" data-id="element-107">
                $
              </span>
              <span className="text-7xl font-playfair font-bold text-cream-100" data-id="element-108">
                6.39
              </span>
              <span className="text-xl font-playfair text-amber-500 mt-auto mb-2 ml-2" data-id="element-109">
                USD
              </span>
            </div>

            <motion.a href="https://rutinasimple.com//cart/52060392587545:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="w-full py-5 px-8 bg-amber-500 hover:bg-amber-400 text-forest-900 font-bold text-xl rounded-sm shadow-[0_0_20px_rgba(200,169,110,0.5)] transition-all duration-300 uppercase tracking-wider border border-amber-300 flex items-center justify-center gap-3 relative overflow-hidden group" data-id="element-110">
              <span className="absolute inset-0 w-full h-full bg-white/20 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-111"></span>
              ¡Quiero mi botiquín de cocina ahora!
            </motion.a>

            <div className="mt-8 space-y-3 text-cream-200/70 font-lora text-sm flex flex-col items-center" data-id="element-112">
              <div className="flex items-center gap-2" data-id="element-113">
                <Download size={16} className="text-amber-500/70" data-id="element-114" />
                <span data-id="element-115">Descarga instantánea segura.</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-116">
                <ShieldCheck size={16} className="text-amber-500/70" data-id="element-117" />
                <span data-id="element-118">Acceso de por vida.</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}